export default (theme) => ({
	hero: {
		position: "relative",
		zIndex: 2,
		background:
			"linear-gradient(0deg, rgb(179 235 255) 0%, rgba(255,255,255,1) 100%)",
		width: "100%",
	},

	hiwWrapper: {
		padding: "80px 16px 120px",
		[theme.breakpoints.down("xs")]: {
			padding: "80px 16px 100px",
		},
	},
	hiwIcon: {
		fontSize: 50,
		color: theme.palette.primary.main,
	},
	stepBox: {
		borderRadius: 16,
		boxShadow: "rgb(0 0 0 / 10%) 0px -10px 30px",
		padding: 24,
		height: "100%",
	},
	joinH2: {
		fontSize: 44,
		fontWeight: 600,
		lineHeight: "54px",
		marginTop: 0,
		marginBottom: 80,
		textAlign: "center",
		[theme.breakpoints.down("xs")]: {
			fontSize: 34,
			lineHeight: "38px",
		},
	},
	joinH3: {
		fontSize: 22,
		fontWeight: 600,
		lineHeight: 1.3,
		marginTop: 12,
		marginBottom: 16,
		[theme.breakpoints.down("xs")]: {
			//fontSize: 32,
			//lineHeight: "38px",
		},
	},
	joinBodyText: {
		fontSize: 16,
		lineHeight: 1.5,
		[theme.breakpoints.down("xs")]: {
			fontSize: 15,
			lineHeight: 1.5,
		},
	},
	quoteWrapper: {
		padding: "120px 16px",
		[theme.breakpoints.down("xs")]: {
			padding: "80px 16px",
		},
	},
	quoteSymbol: {
		fontSize: 100,
		lineHeight: "16px",
		color: theme.palette.primary.main,
	},
	quoteHead: {
		fontSize: 30,
		lineHeight: 1.5,
		fontWeight: 300,
		paddingRight: 20,
		[theme.breakpoints.down("sm")]: {
			paddingRight: 10,
			fontSize: 22,
		},
		[theme.breakpoints.down("xs")]: {
			paddingRight: 0,
		},
	},
});
